"use client";

import { Typography } from "@/components/ui/typography";
import * as images from "@/components/images/Images";
import { memo } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";
import { TRUSTPILOT_REVIEW_URL } from "@/components/screen/start-order/components/Checkout/constants";

const SecurityTrust = ({}: React.ComponentProps<"section">) => {
  return (
    <section className="section overflow-hidden bg-white lg:bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-6 place-content-start md:grid-cols-[minmax(0,0.46fr)_minmax(0,0.54fr)] md:gap-[min(4rem,4.44vw)]">
          <div className="flex-auto min-w-0 rounded-[8px] overflow-hidden inline-flex md:items-start aspect-[1/0.75] sm:aspect-auto">
            <Image
              src={images.securityTrust}
              width={990}
              height={592}
              alt="Laguex illumination"
              className="flex-auto min-w-0 object-top object-cover"
            />
          </div>
          <div className="flex items-center">
            <div className="flex-auto min-w-0 grid grid-cols-1 gap-4 place-content-start text-semantic-text-primary md:gap-6">
              <Typography variant="heading4" className="lg:text-gray-800">
                <h2>Trust built with every word</h2>
              </Typography>
              <div className="text-base leading-[160%] lg:leading-[150%] lg:text-gray-600">
                <p>
                  We’re proud to be the highest-rated human-powered translation
                  service on TrustPilot, with thousands of happy customers.
                </p>
              </div>
              <div>
                {/*
                  2026-05-25 — was href="#" (dead link). Wired to the
                  shared TRUSTPILOT_REVIEW_URL constant so the CTA
                  actually drops the customer on the live Trustpilot
                  review page. Opens in a new tab to keep our session
                  intact.
                */}
                <Button
                  asChild
                  variant="primary"
                  className="sm:w-[206] h-[48px]"
                >
                  <Link
                    href={TRUSTPILOT_REVIEW_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!text-base w-full"
                  >
                    Discover our reviews
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(SecurityTrust);
